import { apiClient } from 'pobble-components/dist/api'

const apiOuathIdentityConnections = data =>
  apiClient.post('/v3/oauth_identity_connections', data)

export { apiOuathIdentityConnections }
